import api from ".";

export const getBanks = (country = "NG") => api.get(`/banks/${country}`);

export const validateAccount = (params) => api.get("/banks/validate-bank-account", { params });

export const addAccount = (data) => api.post("/banks", data);

export const updateAccount = ({ uuid, ...data }) => api.patch(`/banks/${uuid}/update`, data);

export const getAccounts = () => api.get("/banks");

export const getDisabledAccounts = () => api.get("/banks/disabled");

export const disableAccount = ({ uuid }) => api.patch(`/banks/${uuid}/disable`);

export const enableAccount = ({ uuid }) => api.patch(`/banks/${uuid}/enable`);

export const getSettlementTransactions = ({ uuid, ...params }) => api.get(`/banks/${uuid}/transactions`, { params });
